import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import IndeterminateCheckbox from "../components/IndeterminateChechbox";
import Table from "../components/Table";
import axios from "axios";
import { apiKey } from "../config/config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function InventoryCategory({ lang }) {
const token = JSON.parse(sessionStorage.getItem("aman-admin") || 'null')?.admin ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token : null;
 
  // const [inventoryList, setInventoryList] = useState([]);
  // const [inventoryToDelete, setInventoryToDelete] = useState([]);
  const [InventoryCategory, setInventoryCategory] = useState([]);
  const [branchId, setBranchId] = useState();
  const [itemComodity, setItemComodity] = useState();

  const userRole = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin") || "null")?.admin || "{}"
  )?.role;

  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);

  // const returnTable = async (table) => {
  //   await setInventoryToDelete(table.map((item) => item.original.id));
  // };

  const handleComoditySubmit = (e) => {
    e.preventDefault();

    const payload = {
      item_type: itemComodity,
      branch_id: branchId,
    };

    const apiCall = isEditMode
      ? axios.put(apiKey + `/update-item-type/${editId}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
      : axios.post(apiKey + "/add-item-type", payload, {
          headers: { Authorization: `Bearer ${token}` },
        });

    apiCall
      .then((res) => {
        setItemComodity("");
        setIsEditMode(false);
        setEditId(null);
        // refresh list
        if (branchId) {
          axios
            .get(apiKey + "/get-item-type", {
              params: { branch_id: branchId },
              headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
              setInventoryCategory(res.data.result);
            });
        }
        toast.success(res.data.Message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        console.error(err);
        toast.error("Error Occured", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const handleDelete = (item) => {
    if (item.inventory_count > 0) {
      toast.error(
        lang.Category_Has_Items || "Cannot delete category because it contains items.",
        {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        }
      );
      return;
    }

    if (
      window.confirm(
        lang.Confirm_Delete || "Are you sure you want to delete this category?"
      )
    ) {
      axios
        .delete(apiKey + `/delete-item-type/${item.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          toast.success(res.data.Message || "Category deleted successfully", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          // refresh list
          if (branchId) {
            axios
              .get(apiKey + "/get-item-type", {
                params: { branch_id: branchId },
                headers: { Authorization: `Bearer ${token}` },
              })
              .then((res) => {
                setInventoryCategory(res.data.result);
              });
          }
        })
        .catch((err) => {
          console.error(err);
          toast.error(err?.response?.data?.Error || "Error Occured", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  };

  const columns = [
    {
      header: lang.category || "Category",
      accessorKey: "type",
    },
    {
      header: lang.item_count || "Item count",
      accessorKey: "inventory_count",
    },
    {
      header: lang.Actions || "Actions",
      cell: (row) => (
        <div className="dropdown top-0 start-0">
          {(userRole === "dealer" || userRole === "super") && (
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {lang.Actions || "Actions"}
          </button>
          )}
          <ul className="dropdown-menu">
            {(userRole === "dealer" || userRole === "super") && (
              <li>
                <button
                  className="dropdown-item mt-0"
                  data-bs-toggle="modal"
                  data-bs-target="#Comodity"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsEditMode(true);
                    setEditId(row.row.original.id);
                    setItemComodity(row.row.original.type);
                  }}
                >
                  {lang["Edit Category"] || "Edit Category"}
                </button>
              </li>
            )}
            {(userRole === "dealer" || userRole === "super") && (
              <li>
                <button
                  className="dropdown-item mt-0 text-danger"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDelete(row.row.original);
                  }}
                >
                  {lang["Delete Category"] || lang.Delete || "Delete Category"}
                </button>
              </li>
            )}
          </ul>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (branchId){
      axios
        .get(apiKey + "/get-item-type", {
          params: {
            branch_id: branchId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setInventoryCategory(res.data.result);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [branchId, token]);

  useEffect(() => {
    setBranchId(
      JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).branch_id
    );
  }, []);
  return (
    <>
      <main id="main" className="main">
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <div className="pagetitle">
          <h1>
            {lang.Investment_Loan_Management || "Investment/Loan Management"}
          </h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                >
                  <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                </svg>
              </li>
              <li className="breadcrumb-item ">
                {lang.Investment_Loan_Management ||
                  "Investment/Loan Management"}
              </li>
              <li className="breadcrumb-item active">
                {lang.category || "Category List"}
              </li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="row justify-content-end">
                  <div className="col-md-5 col-lg-3">
                    <button
                      type="button"
                      className="btn-primary btn"
                      data-bs-toggle="modal"
                      data-bs-target="#Comodity"
                      onClick={() => {
                        setIsEditMode(false);
                        setEditId(null);
                        setItemComodity("");
                      }}
                    >
                      {lang.Add_Category || "Add Category"}
                    </button>
                  </div>
                </div>

                <div className="row pt-3">
                  <div className="rr col-9">{lang.category || "Category List"}</div>
                </div>

                <div className="card-body">
                  <div classNames="d-flex mt-3 mb-3"></div>
                  <div classNames="d-flex mt-3 mb-3">
                    <Table
                      lang={lang}
                      data={InventoryCategory}
                      columns={columns}
                      // returnTable={returnTable}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="modal fade" id="Comodity" tabindex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <form onSubmit={handleComoditySubmit}>
                  <div className="row mb-3 mt-5 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {isEditMode ? lang.Edit_Category || "Edit Category" : lang.add_item_category || "Add Item Category"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={itemComodity}
                          onChange={(e) => setItemComodity(e.target.value)}
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="text-center mb-5">
                    <button
                      type="button"
                      className="btn-save"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        setIsEditMode(false);
                        setEditId(null);
                        setItemComodity("");
                      }}
                    >
                      {lang.Cancel || "Cancel"}
                    </button>
                    <button type="submit" className="btn-cancel ms-5" data-bs-dismiss="modal" onClick={handleComoditySubmit}>
                      {isEditMode ? lang.Save || "Save" : lang.Add_Now || "Add Now"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
